import { max } from 'lib/arrayUtils'

function getTourV2VariationDuration(variation: Tours.V2OfferVariation) {
  const lastDay = max(variation.itinerary ?? [], (item) => item.startDay)! // guaranteed to exist
  const daysCount = lastDay.startDay + lastDay.duration - 1

  return daysCount
}

export default getTourV2VariationDuration
